"use client";

interface NavbarProps {
  onBookDemo?: () => void;
  onOpenDemo?: () => void;
}

export default function Navbar({ onBookDemo, onOpenDemo }: NavbarProps) {
  const handleDemo = onBookDemo || onOpenDemo;
  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-200/80 transition-all">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <img
              src="https://echoleads.ai/assets/Echoleads%20Logo-02%203.png"
              alt="EchoLeads Logo"
              className="h-8 w-auto group-hover:scale-105 transition-transform"
            />
          </a>

          {/* Right Navigation */}
          <div className="flex items-center gap-8">
            <a
              href="tel:+919000164308"
              className="text-sm font-medium text-slate-300 hover:text-white transition-colors hidden sm:block"
            ></a>
            <a
              href="https://echoleads.ai/contact"
              className="inline-block px-6 py-2.5 rounded-lg bg-[#F2A339] hover:bg-[#E08D26] text-slate-950 font-bold text-sm transition-all transform hover:-translate-y-0.5 shadow-md shadow-[#F2A339]/20 cursor-pointer whitespace-nowrap"
            >
              Book a demo
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
